var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_589_12213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 17.4999C35 27.1649 27.1651 35 17.5001 35C7.83501 35 0 27.1649 0 17.4999C0 7.83497 7.83501 0 17.5001 0C27.165 0 35 7.83497 35 17.4999Z",
    fill: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2847 17.5C31.2847 25.1125 25.1132 31.2845 17.5003 31.2845C9.88748 31.2845 3.71558 25.1125 3.71558 17.5C3.71558 9.88691 9.88748 3.71533 17.5003 3.71533C25.1133 3.71533 31.2847 9.8868 31.2847 17.5Z",
    fill: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4773 22.1748L17.6139 17.8947L20.3051 16.9115L20.9744 14.3961L20.9516 14.3337L18.3026 15.3015L20.2112 8.11475H14.7982L12.3022 17.4936L10.2182 18.2549L9.52954 20.8481L11.612 20.0875L10.1409 25.6149H24.5469L25.4704 22.1748H16.4773Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_589_12213"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLtc);
export default __webpack_public_path__ + "static/media/ltc.adb4ff8b5d6f69390bf4eddfe33e2c7c.svg";
export { ForwardRef as ReactComponent };